import { GamesListPage } from "./GamesListPage";
export default GamesListPage;
